import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  Icon,
  InputGroup,
  Spinner,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { newIProdutoPage, IProdutoPage } from "../../model";
import { toast } from "react-toastify";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
const InputMask = require("react-input-mask");

interface ProdutoDialogCreateProps {
  onClose: () => void;
  estado: string;
}

interface ProdutoDialogCreateState {
}

@observer
export class ProdutoDialogCreate
  extends React.Component<ProdutoDialogCreateProps, ProdutoDialogCreateState> {
  obs = observable({
    produto: newIProdutoPage() as IProdutoPage
  })

  async componentDidMount() {
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleSave = async () => {

    const { descricao, ncm } = this.obs.produto;

    if (descricao === "") {
      toast.error("Descrição não pode ser vazia");
      return;
    }

    if (ncm === "") {
      toast.error("NCM não pode ser vazio");
      return;
    }

    try {
      this.obs.produto.estado = this.props.estado
      let resp = await api_adm.post("/api/admin/produtos", this.obs.produto);
      if (resp.data.ok) {
        toast.success('Produto criado', {});
        window.location.reload();
      } else {
        toast.error(`Produto não criado: ${resp.data.msg}`, {});
      }
    } catch (ex) {
      toast.error('Erro ao criar Produto"', {});
    }
  };

  renderData() {
    let dayPickerProps = {
          localeUtils: MomentLocaleUtils,
          locale: "pt-br",
        };
    return (
      <div>
        <FormGroup
          label="Descrição"
          labelFor="descricao"
        >
          <InputGroup
            id="descricao"
            style={{ width: 400 }}
            onChange={(e: any) => this.obs.produto.descricao = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="NCM (separador por vírgula e com ponto)"
          labelFor="ncm"
        >
          <InputGroup
            id="ncm"
            style={{ width: 200 }}
            onChange={(e: any) => this.obs.produto.ncm = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="CEST"
          labelFor="cest"
        >
          <InputMask
            id="cest"
            mask="99.999.99"
            className="form-control"
            onChange={(e: any) => this.obs.produto.cest = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="Validade"
          labelFor="validade"
        >
          <div style={{ width: 600, display: "flex", alignItems: "center" }}>
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_de ? new Date(this.obs.produto.valido_de) : null}
              onChange={val =>
                this.obs.produto.valido_de = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
            <Icon icon="arrow-right" style={{ margin: "0 10px" }} />
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_ate
                ? new Date(this.obs.produto.valido_ate)
                : null}
              onChange={val =>
                this.obs.produto.valido_ate = val}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
          </div>
        </FormGroup>

        <Switch
          checked={this.obs.produto.entrada}
          onChange={(e: any) => this.obs.produto.entrada = e.target.checked}
          innerLabelChecked="Entrada" innerLabel="Saída"
          style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
        />

      </div>
    );
  }

  render() {

    let title = "Detalhes";
    
    if (this.obs.produto) {
      title = this.obs.produto.descricao.substring(0, 100);
    }

    return (
      <Dialog
        isOpen={true}
        title={title}
        onClose={this.props.onClose}
        style={{ width: 800, height: 600 }}
      >
        <div className={Classes.DIALOG_BODY}>
          {this.renderData() || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Salvar" intent="primary" onClick={this.handleSave} />
          </div>
        </div>
      </Dialog>
    );
  }
}
